import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { asyncScheduler } from 'rxjs';
import { AsyncScheduler } from 'rxjs/internal/scheduler/AsyncScheduler';
import {
  BreadcrumbsComponent,
  ButtonModule,
  CardModule,
  CarouselModule,
  DateTimeCardModule,
  IconModule,
  TagModule,
} from '@yoimo/joymo-ui';

import { TicketOptionsModule } from '../ticket-options/ticket-options.module';
import { VideoComponent } from './video.component';
import { VideoControlComponent } from './video-control/video-control.component';
import { VideoPlayerModule } from '../../video-player/video-player.module';
import { VideoRoutingModule } from './video-routing.module';
import { VideoStateComponent } from './video-state/video-state.component';
import { VideoFeedbackComponent } from './video-feedback/video-feedback.component';
import {
  DescriptionBlockComponent,
  InfoBlockComponent,
  LiveAndUpcomingComponent,
  SocialShareComponent,
  TagsListComponent,
  VideosListComponent,
  HelpComponent,
} from 'shared-lib';

@NgModule({
  declarations: [VideoComponent, VideoStateComponent],
  imports: [
    CardModule,
    CarouselModule,
    CommonModule,
    IconModule,
    TagModule,
    CarouselModule,
    CardModule,
    TagsListComponent,
    RouterModule,
    VideoPlayerModule,
    VideoRoutingModule,
    ButtonModule,
    TicketOptionsModule,
    VideosListComponent,
    DateTimeCardModule,
    HelpComponent,
    VideoControlComponent,
    LiveAndUpcomingComponent,
    InfoBlockComponent,
    VideoFeedbackComponent,
    BreadcrumbsComponent,
    DescriptionBlockComponent,
    SocialShareComponent,
  ],
  providers: [{ provide: AsyncScheduler, useValue: asyncScheduler }],
})
export class VideoModule {}
